<p i18n="Success message for account deletion@@ACCOUNT_DELETED">Your account has been successfully deleted.</p>